import React from "react"

function IconCheckmarkAltCircle({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="checkmark-alt-circle"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-checkmark-alt-circle"
      {...props}
    >
      <path
        d="M11.935 2.302a9.59 9.59 0 0 1 5.681 1.853l-.871.986a8.325 8.325 0 1 0 3.07 4.104l.977-1.105c.5 1.165.776 2.448.776 3.796 0 5.32-4.313 9.633-9.633 9.633-5.32 0-9.633-4.313-9.633-9.633 0-5.32 4.313-9.634 9.633-9.634zm8.026 2.99c.24.212.287.563.127.828l-.07.095-8.68 9.819a.655.655 0 0 1-.893.082l-.083-.078-4.412-4.909a.655.655 0 0 1 .887-.955l.086.08 3.921 4.361 8.193-9.267a.655.655 0 0 1 .924-.057z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCheckmarkAltCircle
